// Maps AMSG contract revert codes to friendly user messages.

const ERROR_MESSAGES = {
  OW: 'Only owner can perform this action',
  OA: 'Only admin can perform this action',
  OOA: 'Only owner or admin can perform this action',
  REG: 'This wallet is already registered',
  NR: 'You are not registered. Please register first.',
  IR: 'Invalid referrer ID',
  IU: 'Invalid user',
  IP: 'Invalid plan selected',
  IL: 'Invalid level',
  II: 'Invalid investment index',
  IPR: 'Invalid price',
  ITF: 'Invalid timeframe',
  IO: 'Invalid owner',
  IA: 'Invalid address',
  IM: 'Invalid minimum value',
  IMU: 'Invalid multiple value',
  IPE: 'Invalid period value',
  MIN: 'Amount is below the minimum required',
  MULT: 'Amount must be a valid multiple',
  MAX: 'Maximum users reached',
  BL: 'This account is blacklisted',
  BLAO: 'Cannot blacklist owner or admin',
  NA: 'Account is not active',
  NF: 'User not found',
  TF: 'USDT transfer failed. Check your balance and approval.',
  NRC: 'No rewards available to claim',
  AW: 'This principal has already been withdrawn',
  NRI: 'Only real investments can be withdrawn',
  F10: 'Fee cannot exceed 10%',
  F50: 'Fee cannot exceed 50%',
  E100: 'Value cannot exceed 100%',
  RTH: 'ROI value is too high',
  USE: 'Please use Register & Invest',
  MAXROI: 'Investment has reached maximum ROI',
  PW: 'Principal has been withdrawn',
  LIM: 'Daily withdraw limit reached. Try again after the 24h window resets.'
};

export const parseContractError = (error) => {
  if (!error) return 'Unknown error occurred';

  if (error.code === 4001 || error.code === 'ACTION_REJECTED') {
    return 'Transaction rejected by user';
  }

  if (error.code === -32603 || error.code === 'UNPREDICTABLE_GAS_LIMIT') {
    const reason = extractRevertReason(error);
    if (reason) return reason;
    return 'Transaction failed. Please check your inputs.';
  }

  if (error.code === 'INSUFFICIENT_FUNDS') {
    return 'Insufficient BNB for gas fees';
  }

  if (error.code === 'NETWORK_ERROR') {
    return 'Network error. Please check your connection.';
  }

  const reason = extractRevertReason(error);
  if (reason) return reason;

  if (error.message) {
    if (error.message.includes('user rejected')) return 'Transaction rejected by user';
    if (error.message.includes('insufficient funds')) return 'Insufficient funds for gas';
    if (error.message.includes('network')) return 'Network error. Please try again.';
    return error.message.split('(')[0].trim().slice(0, 120);
  }

  return 'Transaction failed. Please try again.';
};

const extractRevertReason = (error) => {
  const candidates = [
    error?.reason,
    error?.data?.message,
    error?.error?.data?.message,
    error?.error?.message,
    error?.error?.reason
  ];

  for (const c of candidates) {
    if (typeof c === 'string') {
      const matched = matchCode(c);
      if (matched) return matched;
    }
  }

  if (typeof error.message === 'string') {
    const matched = matchCode(error.message);
    if (matched) return matched;
  }

  return null;
};

const matchCode = (text) => {
  const m1 = text.match(/reverted with reason string ['"]([^'"]+)['"]/);
  if (m1 && ERROR_MESSAGES[m1[1]]) return ERROR_MESSAGES[m1[1]];

  const m2 = text.match(/execution reverted:?\s*([A-Z0-9]+)/);
  if (m2 && ERROR_MESSAGES[m2[1]]) return ERROR_MESSAGES[m2[1]];

  for (const code of Object.keys(ERROR_MESSAGES)) {
    const re = new RegExp(`\\b${code}\\b`);
    if (re.test(text)) return ERROR_MESSAGES[code];
  }
  return null;
};
